import React, { useState } from "react";
import "./App.css";
import Dashboard from './components/Contents/dashboard'
import { Route, Switch } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import AuthGuard from './common/AuthGuard'
import LoginPageNew from "./components/LoginPageNew";
import { UserContext } from "./contexts/UserContext";

function App() {
  const [userDetail, setUserContext] = useState({
    username: "",
    roles: [],
    plaza: [],
    userType: "",
  });
  return (
    <UserContext.Provider value={{ ...userDetail, setUserContext }}>
      <React.Fragment>
        <ToastContainer />
        <Switch>
          <Route path="/" exact component={LoginPageNew} />
          <Route path="/dashboard">
            <AuthGuard Comp={Dashboard} />
          </Route>
        </Switch>
      </React.Fragment>
    </UserContext.Provider>
  );
}

export default App;
